// extracted by mini-css-extract-plugin
export default {"app_main":"App_app_main__SyHjL"};